import { HttpResponse, OrderHistories, Orders } from "../types";
import HttpClientRequest from "../api/client-request";
import { OrderCheckoutData } from "../data/order-check-data";

export default class OrderService {

    static async createOrder(orderPayload: OrderCheckoutData, requestId?: string): Promise<HttpResponse> {
        let response;
        try {
            
            response = await HttpClientRequest.doPostRequest('/orders/create', orderPayload, {
                'Content-Type': 'application/json'
            }, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
    
    static async getOrdersByOrderNumber(orderNumber: string, requestId?: string): Promise<Orders|undefined> {
        try {
            
            const response = await HttpClientRequest.doGetRequest(`/orders/${orderNumber}`, {}, requestId);

            if (response.status === 200) {
                return response.data;
            }

            return undefined;

        } catch (error) {
            console.error("Error fetching orders:", error);
            return undefined;
        }
    }
    
    static async getOrdersByUserId(userId: string, requestId?: string): Promise<Orders[]> {
        try {
            
            const response = await HttpClientRequest.doGetRequest(`/customer/${userId}/orders`, {}, requestId);

            if (response.status === 200) {
                return response.data;
            }

            return [];

        } catch (error) {
            console.error("Error fetching orders:", error);
            return [];
        }
    }
    
    static async trackOrder(orderNumber: string, requestId?: string): Promise<OrderHistories[]> {
        try {
            
            const response = await HttpClientRequest.doGetRequest(`/orders/track/${orderNumber}`, {}, requestId);

            if (response.status === 200) {
                return response.data;
            }

            return [];

        } catch (error) {
            console.error("Error fetching orders:", error);
            return [];
        }
    }
}